import React, { useState } from 'react';
import api from '../api';
import { useAuth } from '../App';

const AVATARS = ['😊','👨','👩','👦','👧','🧑','👴','👵','🦸','🧙','🎅','🧑‍🍳','👩‍🎓','👨‍💼','🧑‍🏫','🎃'];
const COLORS = ['#6C63FF','#FF7043','#4CAF50','#2196F3','#E91E63','#9C27B0','#00BCD4','#FF9800','#795548','#607D8B'];

export default function Login() {
  const { login } = useAuth();
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [avatar, setAvatar] = useState('😊');
  const [color, setColor] = useState('#6C63FF');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const endpoint = mode === 'login' ? '/auth/login' : '/auth/register';
      const payload = mode === 'login' ? { email, password } : { name, email, password, color, avatar_emoji: avatar };
      const { data } = await api.post(endpoint, payload);
      login(data.token, data.user);
    } catch (e) {
      setError(e.response?.data?.error || 'Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-logo">🏠</div>
      <div className="login-title">FamilyOS</div>
      <div className="login-subtitle">Votre assistant familial intelligent</div>

      <div className="login-card">
        <div className="tabs" style={{ marginBottom: 20 }}>
          <button className={`tab${mode === 'login' ? ' active' : ''}`} onClick={() => { setMode('login'); setError(''); }}>Se connecter</button>
          <button className={`tab${mode === 'register' ? ' active' : ''}`} onClick={() => { setMode('register'); setError(''); }}>Créer un compte</button>
        </div>

        <form onSubmit={handleSubmit}>
          {mode === 'register' && (
            <>
              <div className="form-group">
                <label className="form-label">Votre prénom</label>
                <input className="form-input" placeholder="Ex: Fred, Sophie..." value={name} onChange={e => setName(e.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label">Choisir un emoji</label>
                <div className="emoji-grid">
                  {AVATARS.map(em => (
                    <button key={em} type="button" className={`emoji-btn${avatar === em ? ' selected' : ''}`} onClick={() => setAvatar(em)}>{em}</button>
                  ))}
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Couleur</label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {COLORS.map(c => (
                    <button key={c} type="button" onClick={() => setColor(c)} style={{ width: 32, height: 32, borderRadius: '50%', background: c, border: color === c ? '3px solid white' : '3px solid transparent', outline: color === c ? `3px solid ${c}` : 'none', cursor: 'pointer' }} />
                  ))}
                </div>
              </div>
            </>
          )}

          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" type="email" placeholder="votre@email.fr" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="form-group" style={{ marginBottom: 20 }}>
            <label className="form-label">Mot de passe</label>
            <input className="form-input" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>

          {error && <div style={{ background: '#FFEBEE', color: '#C62828', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 13, fontWeight: 600 }}>⚠️ {error}</div>}

          <button type="submit" className="btn btn-primary" style={{ width: '100%', fontSize: 16, padding: '13px' }} disabled={loading}>
            {loading ? <span className="spinner" style={{ width: 20, height: 20 }} /> : (mode === 'login' ? 'Se connecter' : 'Créer mon compte')}
          </button>
        </form>

        {mode === 'login' && (
          <div className="text-muted text-center mt-12" style={{ fontSize: 12 }}>
            Compte par défaut : admin@family.local / password
          </div>
        )}
      </div>
    </div>
  );
}
